<script lang="ts" setup>
const { buttonType, arrow, arrowLeft, submit, large, small, round, disabled } = defineProps({
  buttonType: {
    type: String,
    default: 'primary',
  },
  arrow: {
    type: Boolean,
    default: false,
  },
  arrowLeft: {
    type: Boolean,
    default: false,
  },
  submit: {
    type: Boolean,
    default: false,
  },
  large: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  round: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
const { isShipzee } = useTheme()

const btnClass = computed(() => {
  return {
    'btn-primary': buttonType === 'primary',
    'btn-purple': buttonType === 'purple',
    'btn-secondary': buttonType === 'secondary',
    'btn-secondary-orange': buttonType === 'secondary-orange',
    'btn-trinary': buttonType === 'trinary',
    'btn-white': buttonType === 'white',
    'btn-orange': buttonType === 'orange',
    'btn-arrow-right': arrow,
    'btn-arrow-left': arrowLeft,
    'btn-large': large,
    'btn-small': small,
    'btn-round': round,
  }
})

const btnType = computed(() => {
  return submit ? 'submit' : 'button'
})
</script>

<template>
  <button :class="btnClass" :type="btnType" :disabled="disabled">
    <template v-if="arrowLeft">
      <span :class="{ 'arrow-small': small }" class="arrow">
        <i
          class="fa-solid"
          :class="{
            'fa-arrow-left': isShipzee,
            'fa-chevron-left': !isShipzee,
          }"></i>
      </span>
    </template>
    <slot />
    <template v-if="arrow">
      <span :class="{ 'arrow-small': small }" class="arrow">
        <i
          class="fa-solid"
          :class="{
            'fa-arrow-right': isShipzee,
            'fa-chevron-right': !isShipzee,
          }"></i>
      </span>
    </template>
  </button>
</template>
